const useSSOEmail = (email: string) => {
  //get email
  //get the domin from the email
  //check to make sure it is in the list
  //if it is in the list return true

  const emailDomain = email?.toLowerCase().split('@')[1]

  var arr = [
    'jyrney.com',
    'tripstax.com',
    'agiito.com',
    'mclaren.com',
    'flycutprice.uk',
    'cttravelgroup.co.uk',
    'forseven-ev.com',
  ]

  return arr.indexOf(emailDomain) > -1
}

export default useSSOEmail
